import { ShieldAlert, LogOut, Terminal } from "lucide-react"
import { useAuth } from "../components/AuthProvider"

export default function UnauthorizedPage() {
    const { signOut, user } = useAuth()

    return (
        <div className="min-h-screen flex items-center justify-center bg-stone-950 p-4 rounded-2xl overflow-hidden">
            <div className="max-w-md w-full bg-black/40 backdrop-blur-2xl border border-white/[0.08] rounded-2xl p-8 flex flex-col items-center text-center">
                <div className="w-14 h-14 rounded-full bg-red-500/15 border border-red-400/25 flex items-center justify-center mb-6">
                    <ShieldAlert className="w-7 h-7 text-red-400" />
                </div>

                <h1 className="text-[11px] font-mono font-bold uppercase tracking-widest text-white/90 mb-2">
                    Access Denied
                </h1>
                <p className="font-mono text-[13px] text-white/50 mb-6">
                    The email{" "}
                    <span className="text-white/80 font-bold">{user?.email}</span>{" "}
                    is not authorized to access this portal.
                </p>

                <div className="w-full bg-white/[0.02] border border-white/[0.05] rounded-xl p-4 mb-8 text-left">
                    <div className="flex items-center gap-2 mb-3">
                        <Terminal className="w-3.5 h-3.5 text-white/30" />
                        <span className="text-[10px] font-mono text-white/30 uppercase tracking-widest">access trace</span>
                    </div>
                    <div className="font-mono text-[11px] text-white/40 space-y-1">
                        <p><span className="text-red-400/60">AUTH</span> identity_check <span className="text-white/20">failed</span></p>
                        <p><span className="text-white/20">→</span> must be an existing client to sign in</p>
                        <p><span className="text-white/20">→</span> email must match records exactly</p>
                    </div>
                </div>

                <button
                    onClick={() => signOut()}
                    className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-mono text-[13px] font-bold bg-red-500/15 border border-red-400/25 text-red-400 hover:bg-red-500/25 transition-colors cursor-pointer"
                >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                </button>
            </div>
        </div>
    )
}
